import styled from '@emotion/styled'
import React from 'react'

import { FaFacebook, FaInstagram, FaTwitter, FaLinkedin } from 'react-icons/fa'
import { Link, HStack, Box } from '@chakra-ui/react'

type SocialMediaLinksProps = {}
const SocialIcon = styled(Link)`
  cursor: pointer;
  font-size: 1.4rem;
`
const SocialMediaLinks: React.FC<SocialMediaLinksProps> = ({}) => {
  return (
    <HStack spacing={6}>
      <Box color="facebook.300">
        <Link target="_blank" href="https://www.facebook.com/Nsoko-Property-104256128745030">
          <SocialIcon>
            <FaFacebook />
          </SocialIcon>
        </Link>
      </Box>
      <Box>
        <Link target="_blank" href="https://www.instagram.com/nsokooproperty">
          <SocialIcon>
            <FaInstagram />
          </SocialIcon>
        </Link>
      </Box>
      <Box color="twitter.300">
        <SocialIcon>
          <FaTwitter />
        </SocialIcon>
      </Box>
      <Box color="linkedin.500">
        <SocialIcon>
          <FaLinkedin />
        </SocialIcon>
      </Box>
    </HStack>
  )
}

export default React.memo(SocialMediaLinks)
